(() => {
  const sectionSelector = "[data-product-video-social]";
  const instances = new Map();

  const getSectionById = (sectionId) => document.querySelector(`${sectionSelector}[data-section-id="${sectionId}"]`);

  const bindCardControls = (section) => {
    section.querySelectorAll("[data-product-video-social-card]").forEach((card) => {
      const button = card.querySelector("[data-product-video-social-toggle]");
      if (!button || button.dataset.videoSocialBound === "true") return;

      button.dataset.videoSocialBound = "true";
      button.addEventListener("click", () => {
        button.classList.toggle("active");

        const video = card.querySelector("video");
        if (!video) return;

        if (button.classList.contains("active")) {
          video.muted = false;
          video.setAttribute("mute", "false");
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(() => {});
          }
        } else {
          video.pause();
        }
      });
    });
  };

  const initSection = (section) => {
    if (!section || typeof Swiper === "undefined") return;

    const slider = section.querySelector("[data-product-video-social-slider]");
    const nextButton = section.querySelector("[data-product-video-social-next]");
    const prevButton = section.querySelector("[data-product-video-social-prev]");
    if (!slider || !nextButton || !prevButton) return;

    const sectionId = section.dataset.sectionId;
    const existing = instances.get(sectionId);
    if (existing) {
      existing.destroy(true, true);
      instances.delete(sectionId);
    }

    slider.classList.remove("preview");

    const swiper = new Swiper(slider, {
      speed: 300,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton
      },
      breakpoints: {
        320: {
          spaceBetween: 20,
          slidesPerView: 1.3
        },
        768: {
          spaceBetween: 20,
          slidesPerView: 3
        },
        1024: {
          spaceBetween: 20,
          slidesPerView: 5
        }
      }
    });

    instances.set(sectionId, swiper);
    bindCardControls(section);
  };

  const unloadSection = (sectionId) => {
    const instance = instances.get(sectionId);
    if (instance) {
      instance.destroy(true, true);
      instances.delete(sectionId);
    }
  };

  const initAll = () => {
    document.querySelectorAll(sectionSelector).forEach((section) => initSection(section));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      if (!event?.detail?.sectionId) return;
      const section = getSectionById(event.detail.sectionId);
      initSection(section);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      if (!event?.detail?.sectionId) return;
      unloadSection(event.detail.sectionId);
    });
  }
})();
